import { NavPC } from 'mod/store/nav/NavPC';
import cn from 'classnames';
import styles from './index.module.less';

export const HeaderNav: React.FC = () => {
    return (
        <NavPC
            className={cn(styles.nav, 'page-wrapper text-center relative')}
            popupClassName={styles.overlay}
        />
    )
}
export default HeaderNav;